import { render, staticRenderFns } from "./AcaoObjetoCampoSelect.vue?vue&type=template&id=33890247&scoped=true"
import script from "./AcaoObjetoCampoSelect.vue?vue&type=script&lang=js"
export * from "./AcaoObjetoCampoSelect.vue?vue&type=script&lang=js"
import style0 from "./AcaoObjetoCampoSelect.vue?vue&type=style&index=0&id=33890247&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33890247",
  null
  
)

export default component.exports